/* tslint:disable */
/* eslint-disable */
/**
 * esign
 * eSign template authoring and request management service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const EsignManualTrigger = {
    Grid: 'manual_grid',
    Facesheet: 'manual_facesheet'
} as const;
export type EsignManualTrigger = typeof EsignManualTrigger[keyof typeof EsignManualTrigger];


export function EsignManualTriggerFromJSON(json: any): EsignManualTrigger {
    return EsignManualTriggerFromJSONTyped(json, false);
}

export function EsignManualTriggerFromJSONTyped(json: any, ignoreDiscriminator: boolean): EsignManualTrigger {
    return json as EsignManualTrigger;
}

export function EsignManualTriggerToJSON(value?: EsignManualTrigger | null): any {
    return value as any;
}

